<template>
    <v-card class="card-container">
        <v-card-title>
            <v-row no-gutters class="header">
                <v-col>
                    <span class="subheader-label">Регистрация:</span> <span class="subheader-strong-label">24.12.2020</span>
                </v-col>
                <v-col>
                    <span class="subheader-label">Зарегистрировал:</span> <span class="subheader-strong-label">Васильков В.П.</span>
                </v-col>
                <v-spacer class="hide-on-mobile"></v-spacer>
                <v-col cols="auto">
                    <v-btn
                            outlined
                            color="var(--color-2)"
                            size="sm"
                            @click="deleteItem"
                    >
                        Удалить партнера
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="h-100 p-0" style="overflow-y: scroll">
            <b-container fluid class="h-100">
                <v-row no-gutters class="h-100">
                    <v-col class="py-5" xs="12" sm="12" md="6" lg="6" xl="6">
                        <div class="custom-group-label my-2">Общее</div>
                        <b-row no-gutters class="mb-2">
                            <b-col>
                                <label class="custom-input-label">Наименование организации</label>
                                <b-input
                                        v-model="editModel.orgName"
                                        :state="errors.findIndex(x=>x.key='orgName')!=-1?editModel.orgName!=null?true:false:null"
                                />
                            </b-col>
                        </b-row>
                        <b-row no-gutters class="mb-2">
                            <b-col>
                                <label class="custom-input-label">Описание</label>
                                <b-textarea
                                        v-model="editModel.description"
                                        required
                                        rows="6"
                                />
                            </b-col>
                        </b-row>
                        <b-row no-gutters class="mb-2">
                            <b-col>
                                <label class="custom-input-label">Сайт</label>
                                <b-input v-model="editModel.siteURL" />
                            </b-col>
                        </b-row>
                        <b-row no-gutters class="mb-1">
                            <b-col>
                                <v-checkbox
                                        v-model="editModel.vip"
                                        color="var(--color-blue)"
                                        hide-details
                                >
                                    <template v-slot:label>
                                        <span class="custom-input-label" style="margin-left: 5px; margin-top: 2px">VIP статус</span>
                                    </template>

                                </v-checkbox>

                            </b-col>
                        </b-row>
                        <b-row class="mb-1">
                            <b-col >
                                <imageLoader :ratioH="1" :editedImage="editModel.smallLogo" size="small" textLabel="Фотография профиля организации (354 x 354)" @file-loaded="smallLogoLoaded"></imageLoader>
                            </b-col>
                        </b-row>
                        <b-row class="mb-1">
                            <b-col cols="6">
                                <imageLoader :editedImage="editModel.bigLogo" textLabel="Фотография страницы (1080 x 540)" @file-loaded="logoLoaded"></imageLoader>

                            </b-col>
                        </b-row>
                        <div class="custom-group-label mb-2">Специализация:</div>
                        <b-row no-gutters class="mb-1">
                            <b-col>
                                <v-checkbox
                                        v-model="editModel.canAddClient"
                                        color="var(--color-blue)"
                                        hide-details
                                >
                                    <template v-slot:label>
                                        <span class="custom-group-label" style="margin-left: 5px; margin-top: 2px">Добавление клиентов</span>
                                    </template>

                                </v-checkbox>

                            </b-col>
                        </b-row>
                        <b-row no-gutters class="mb-1">
                            <b-col>
                                <v-checkbox
                                        v-model="editModel.canExecuteRequest"
                                        color="var(--color-blue)"
                                        hide-details
                                >
                                    <template v-slot:label>
                                        <span class="custom-group-label" style="margin-left: 5px; margin-top: 2px">Прием заявок</span>
                                    </template>

                                </v-checkbox>

                            </b-col>
                        </b-row>
                        <b-row no-gutters class="mb-1">
                            <b-col>
                                <v-checkbox
                                        v-model="editModel.canManageBonus"
                                        color="var(--color-blue)"
                                        hide-details
                                >
                                    <template v-slot:label>
                                        <span class="custom-group-label" style="margin-left: 5px; margin-top: 2px">Активация бонусов</span>
                                    </template>

                                </v-checkbox>

                            </b-col>
                        </b-row>
                        <b-row no-gutters class="mb-1">
                            <b-col>
                                <v-checkbox
                                        v-model="editModel.canAddStocks"
                                        color="var(--color-blue)"
                                        hide-details
                                >
                                    <template v-slot:label>
                                        <span class="custom-group-label" style="margin-left: 5px; margin-top: 2px">Добавление акций</span>
                                    </template>

                                </v-checkbox>

                            </b-col>
                        </b-row>
                        <div class="w-100 mt-4">
                            <v-row no-gutters  justify="space-between">
                                <v-col cols="auto" class="mr-2">
                                    <v-btn
                                            color="var(--color-blue)"
                                            dark
                                            size="sm"
                                            @click="onSave"
                                    >
                                        Сохранить
                                    </v-btn>
                                </v-col>

                            </v-row>
                        </div>
                    </v-col>
                </v-row>
            </b-container>
        </v-card-text>
    </v-card>
</template>

<script>
    import imageLoader from '../ImageLoader.vue'
    import axios from 'axios'
    const apiLink=process.env.VUE_APP_API_LINK
    export default {
        name: "PartnerInfoData",
        props:["item"],
        components:{imageLoader},
        data(){
            return {
                errors:[],
                imageModel:null,
                loading:false,
                imageModelBig:null,
                editModel: {
                    id:null,
                    orgName: null,
                    description: null,
                    siteURL: null,
                    smallLogo:null,
                    bigLogo: null,
                    vip:false,
                    canAddClient: false,
                    canExecuteRequest: false,
                    canManageBonus: false,
                    canAddStocks: false,
                },
            }
        },
        methods:{
            smallLogoLoaded(e){
                this.imageModel=e[0]
                if(e[0]==null)
                this.editModel.smallLogo=null
            },

            logoLoaded(e){
                this.imageModelBig=e[0]
                if(e[0]==null)
                    this.editModel.bigLogo=null
            },

            deleteItem() {
                const vm=this;
                this.$bvModal.msgBoxConfirm('Вы действительно хотите удалить запись?', {
                    title: 'Подтверждение',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Удалить',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                    .then(value => {
                        if(value==true){
                            this.$store.dispatch("Partners/deleteOrganization", vm.item.id).then(()=>{
                                vm.$bvToast.toast("Партнер успешно удален",{
                                    variant: "success",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                                vm.hideDetails(true)
                            }).catch(e=>{
                                vm.$bvToast.toast(e.message, {
                                    title: `Ошибка удаления партнера!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            });
                            this.selected=null;
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
            },

            async onSave() {

                const vm = this;
                //если есть id, то редактируем запись, иначе добавляем
                    try {
                        //если была изменена картинка, то загружаем на сервер
                        if (this.imageModel != null) {
                            var imgId = null;
                            const imgData = new FormData();
                            imgData.append('files', this.imageModel);
                            await axios.post(`${apiLink}FileUpload`, imgData)
                                .then(response => imgId = response.data[0])
                                .catch(error => {
                                    console.log(error)
                                });
                            if (imgId != null)
                                this.editModel.smallLogo = imgId;

                        }

                        //загружаем большой логотип
                        if (this.imageModelBig != null) {
                            var imgId = null;
                            const imgData = new FormData();
                            imgData.append('files', this.imageModelBig);
                            await axios.post(`${apiLink}FileUpload`, imgData)
                                .then(response => imgId = response.data[0])
                                .catch(error => {
                                    console.log(error)
                                });
                            if (imgId != null)
                                this.editModel.bigLogo = imgId;

                        }


                        this.$store.dispatch('Partners/editOrganization', this.editModel).then(() => {
                                this.$bvToast.toast("Организация успешно обновлена", {
                                    variant: "success",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            }
                        ).catch((err) => {
                            this.$bvToast.toast(err, {
                                title: `Ошибка!`,
                                variant: "danger",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })
                        });
                    }catch (e) {
                        console.log(e)
                    }
            },

            hideDetails(isSave){
                this.$emit('hideDetails', isSave)
            }
        },
        mounted(){
            if (this.item != null){
                for (let key in this.editModel) {
                    this.editModel[key] = this.item[key]
                }
            }
            else{
                for (let key in this.editModel) {
                    if (key == "vip")
                        this.editModel[key] = false
                    else
                        this.editModel[key] = null
                }
            }
        },
    }
</script>

<style scoped>
    .header{
        flex-direction: row;
    }

    @media (max-width:1200px){
        .hide-on-mobile{
            display: none;
        }
    }

    @media (max-width:576px){
        .header{
            flex-direction: column;
        }
    }
</style>